import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../common/components/Modal/modal';
import { Formik, Form, useFormik } from 'formik';
import CommonInput from '../../components/Dashboard-res/CommonComponent/CommonInput';
import CommonSelect from '../../components/Dashboard-res/CommonComponent/CommonSelect';
import {
  getAllBanks,
  getEmpanellingBankBranch,
  getCompanyRating,
  editBank
} from '../../common/constants/api';
import { object, string } from 'yup';
import * as _ from 'lodash';
import PopUp from '../../common/components/PopUp/PopUp';
import { DeveloperDataContext } from '../../../../lems-ui/src/pages/app';

const EditBank = ({
  showModal,
  setShowModal,
  setEditBank,
  data,
  companyId
}) => {
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [bankOptions, setBankOptions] = useState([]);
  const [companyRatingOptions, setCompanyRatingOptions] = useState([]);
  const [empanellingBranchOptions, setEmpanellingBranchOptions] = useState([]);

  const context = useContext(DeveloperDataContext);

  const industryRatingOptions = [
    {
      value: 'true',
      label: 'Positive'
    },
    {
      value: 'false',
      label: 'Negative'
    }
  ];

  const segmentRatingOptions = [
    {
      value: 'true',
      label: 'Positive'
    },
    {
      value: 'false',
      label: 'Negative'
    }
  ];

  const validationSchema = object().shape({
    employer_no: string()
      .required()
      .matches(/^[0-9]+$/, 'Must be only digits')
      .min(10, 'Must be exactly 10 digits')
      .max(10, 'Must be exactly 10 digits')
  });

  const formik = useFormik({
    initialValues: {
      bank: {
        value: data?.bankName || '',
        label: data?.bankName || 'Choose Bank'
      },
      company_rating: {
        value: data?.companyRating || '',
        label: data?.companyRating || 'Company Rating'
      },
      empanelling_branch: {
        value: data?.branchName || '',
        label: data?.branchName || 'Empanelling Branch'
      },
      employer_no: data?.employerMasterNumber || '',
      industry_rating: {
        value: data.industryRating || '',
        label: data.industryRating
          ? 'Positive'
          : 'Negative' || 'Industry Rating'
      },
      segment_rating: {
        value: data.segmentRating || '',
        label: data.segmentRating ? 'Positive' : 'Negative' || 'Segment Rating'
      },
      onLoading: true
    },
    validationSchema: validationSchema,
    onSubmit: values => {}
  });

  useEffect(() => {
    let arr = [];
    getAllBanks()
      .then(res => {
        arr = [];
        res.map(each => {
          arr.push({
            value: each?.name,
            label: each?.name
          });
        });
        setBankOptions(arr);
      })
      .catch(err => {});
    getCompanyRating()
      .then(res => {
        arr = [];
        res.map(each => {
          arr.push({
            value: each?.name,
            label: each?.name
          });
        });
        setCompanyRatingOptions(arr);
      })
      .catch(err => {});
    getEmpanellingBankBranch()
      .then(res => {
        arr = [];
        res.map(each => {
          arr.push({
            value: each?.name,
            label: each?.name
          });
        });
        setEmpanellingBranchOptions(arr);
      })
      .catch(err => {});
  }, []);

  const commonFormikFunction = name => {
    if (!name || typeof name != 'string') return;

    return {
      name: name,
      onBlur: formik.handleBlur,
      value: formik.values[name],
      error: formik.touched[name] && formik.errors[name],
      errorMsg: formik.errors[name],
      touched: formik.touched[name],
      setFieldValue: formik.setFieldValue,
      stylesContainer: { maxWidth: '100%' }
    };
  };

  const modalStyle = {
    maxWidth: '600px',
    minWidth: '250px'
  };

  const commonInputDiv = 'md:w-6/12 w-full px-3 py-1 my-2';

  const selectBoxCommonStyle = isDisabled => {
    return {
      dropdownStyle: {
        top: '52px',
        fontSize: '16px'
      },
      stylesContainer: {
        height: '52px',
        ...(isDisabled ? { opacity: '0.5' } : {})
      },
      styleText: {
        fontSize: '14px',
        padding: '0 20px'
      }
    };
  };

  const bankOnChange = e => {
    formik.setFieldValue('bank', {
      value: e.value,
      label: e.label
    });
  };

  const companyRatingOnChange = e => {
    formik.setFieldValue('company_rating', {
      value: e.value,
      label: e.label
    });
  };

  const empanellingBranchOnChange = e => {
    formik.setFieldValue('empanelling_branch', {
      value: e.value,
      label: e.label
    });
  };

  const industryRatingOnChange = e => {
    formik.setFieldValue('industry_rating', {
      value: e.value,
      label: e.label
    });
  };

  const segmentRatingOnChange = e => {
    formik.setFieldValue('segment_rating', {
      value: e.value,
      label: e.label
    });
  };

  const selectFiledCommonFormikFunction = name => {
    if (!name || typeof name != 'string') return;

    return {
      name: name,
      error:
        formik.touched[name] && _.get(formik.errors, `${name}.value`, false),
      touched: formik.touched[name],
      value: formik.values[name]
    };
  };

  const handleEmployerNo = e => {
    let patt = new RegExp(/[0-9]{11}/g);
    let errors = e.target.value.toString().match(patt);
    if (errors) return;
    formik.setFieldValue('employer_no', e.target.value);
  };

  const handleSubmition = () => {
    formik.validateForm().then(res => {
      if (Object.keys(res).length != 0) {
        formik.handleSubmit();
      } else {
        editBankHandle();
      }
    });
  };

  const editBankHandle = () => {
    setEditBank(true);
    setShowModal(false);
    setShow(true);
    setType('loading');
    setText('Updating Bank please wait...');

    let body = {
      id: data?.id,
      companyId: companyId,
      bankName: formik.values?.bank?.value || data?.bankName,
      companyRating: formik.values.company_rating.value || data?.companyRating,
      branchName: formik.values?.empanelling_branch.value || data?.branchName,
      employerMasterNumber:
        formik.values?.employer_no || data?.employerMasterNumber,
      industryRating:
        formik.values?.industry_rating?.value || data?.industryRating,
      segmentRating: formik.values?.segment_rating?.value || data?.segmentRating
    };

    editBank(
      body.id,
      body.companyId,
      body.bankName,
      body.companyRating,
      body.branchName,
      body.employerMasterNumber,
      body.industryRating,
      body.segmentRating
    )
      .then(res => {
        context.setAppData({
          ...context.appData,
          bankReload: !context.appData.bankReload
        });
        if (res.error) throw new Error(res);
        setShow(false);
        setAddBank(false);
      })
      .catch(error => {
        setShow(false);
        setEditBank(false);
      });
  };

  return (
    <Formik
      initialValues={formik.initialValues}
      onSubmit={(values, actions) => {}}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        setFieldError,
        setValues
      }) => {
        return (
          <Form>
            <div className="w-full">
              <Modal
                show={showModal}
                setShow={setShowModal}
                title={
                  <span className="font-bold font-roboto text-xl text-black-0">
                    Edit Bank
                  </span>
                }
                styleContainer={modalStyle}
              >
                <hr
                  className="border-grey-100 w-full"
                  style={{ borderWidth: 'thin' }}
                />
                <div
                  className="w-full overflow-auto"
                  style={{ maxHeight: '80vh', overflow: 'auto' }}
                >
                  <div className="mt-5 md:flex">
                    <div className="w-full px-3 py-1 my-2">
                      <CommonSelect
                        onChange={bankOnChange}
                        options={bankOptions}
                        {...selectBoxCommonStyle(false)}
                        {...selectFiledCommonFormikFunction('bank')}
                        disabled={true}
                      />
                    </div>
                    <div className="w-full px-3 py-1 my-2">
                      <CommonSelect
                        onChange={companyRatingOnChange}
                        options={companyRatingOptions}
                        {...selectBoxCommonStyle(false)}
                        {...selectFiledCommonFormikFunction('company_rating')}
                      />
                    </div>
                  </div>
                  <div className="md:flex ">
                    <div className={`${commonInputDiv}`}>
                      <CommonSelect
                        onChange={empanellingBranchOnChange}
                        options={empanellingBranchOptions}
                        {...selectBoxCommonStyle(false)}
                        {...selectFiledCommonFormikFunction(
                          'empanelling_branch'
                        )}
                        disabled={true}
                      />
                    </div>
                    <div className={`${commonInputDiv}`}>
                      <CommonInput
                        legendName="Employer Master No."
                        {...commonFormikFunction('employer_no')}
                        onChange={handleEmployerNo}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="md:flex ">
                    <div className={`${commonInputDiv}`}>
                      <CommonSelect
                        onChange={industryRatingOnChange}
                        options={industryRatingOptions}
                        {...selectBoxCommonStyle(false)}
                        {...selectFiledCommonFormikFunction('industry_rating')}
                      />
                    </div>
                    <div className={`${commonInputDiv}`}>
                      <CommonSelect
                        onChange={segmentRatingOnChange}
                        options={segmentRatingOptions}
                        {...selectBoxCommonStyle(false)}
                        {...selectFiledCommonFormikFunction('segment_rating')}
                      />
                    </div>
                  </div>
                  <div className="w-full mt-8">
                    <button
                      type="button"
                      onClick={() => {
                        handleSubmition();
                      }}
                      className="submitButton text-16 w-56 h-12 font-medium  font-roboto"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </Modal>
            </div>
            <PopUp type={type} text={text} show={show} setShow={setShow} />
          </Form>
        );
      }}
    </Formik>
  );
};

export default EditBank;
